import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import { FitnessPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import AppUtils from "../../../utils/AppUtils";
import {IFitnessPlanData} from "../../../models/LCPlanClientModels";

export interface PatientFitnessPlansViewProps {
    patientFitnessPlans: IFitnessPlanData
}

let PatientFitnessPlansViewGuidelinesHeaderInfos: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES"}
];

let LifeStyleEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "activity", display: "ACTIVITY"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "duration", display: "DURATION"},
    {label: "advice", display: "ADVICE"}
];

const GuidelinesHeaderInfos: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES"}
]

export default class PatientFitnessPlansView extends React.Component<PatientFitnessPlansViewProps> {

    render () {
        const hasFitnessPlanData = !_isEmpty(this.props.patientFitnessPlans);
        const fitnessActivitiesData = hasFitnessPlanData && !_isEmpty(this.props.patientFitnessPlans.activities) ? this.props.patientFitnessPlans.activities : [];
        const fitnessGuidelinesData = hasFitnessPlanData && !_isEmpty(this.props.patientFitnessPlans.guidelines) ? this.props.patientFitnessPlans.guidelines : [];
        return (
            <div className={"patient-fitness-plan-view-container"}>
                {
                    !_isEmpty(fitnessGuidelinesData) &&
                    <div className={"guidelines-container"}>
                        <CustomHeader headerInfos={GuidelinesHeaderInfos} rootCls={"patient-fitness-plan"}/>
                        {
                            fitnessGuidelinesData.map((guidelineItem: string, index: number) => {
                                return (
                                    <div key={`fitnessGuidelineItem-${index}`} className={"guideline-item"}>{guidelineItem}</div>
                                )
                            })
                        }
                    </div>
                }
                {
                    !_isEmpty(fitnessActivitiesData) &&
                    <div>
                        <CustomHeader headerInfos={LifeStyleEditorHeaderInfos} rootCls={"patient-fitness-plan"}/>
                        {
                            fitnessActivitiesData.map((item: any, index: number) => {
                                const name = item.activity.displayValue;
                                const frequencyCount =  !_isEmpty(item.frequency) ? item.frequency.count : null;
                                const unit = !_isEmpty(item.frequency) ? item.frequency.unit : null;
                                const activityDuration = AppUtils.isDefined(item.duration) ? item.duration : null;
                                let advice = !_isEmpty(item.advice) ? item.advice : "";
                                return (
                                    <div className={`fitness-plan-item-view`}>
                                        <div className={`smart-column fitness-plan-item-view-activity`}>
                                            <span>{name}</span>
                                        </div>
                                        <div className={`smart-column fitness-plan-item-view-frequency`}>
                                            <span>{`${frequencyCount} / ${unit}`}</span>
                                        </div>
                                        <div className={`smart-column fitness-plan-item-view-duration`}>
                                            <span className={"unit-label"}>{`${activityDuration} mins`}</span>
                                        </div>
                                        <div className="smart-column fitness-plan-item-view-advice">
                                            <span>{advice}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    _isEmpty(fitnessActivitiesData) && _isEmpty(fitnessGuidelinesData) &&
                    <div className={"no-fitness-plans-label"}>No Fitness Plans to show</div>
                }
            </div>
        )
    }
}